import { gql } from '@apollo/client';

export default gql`
  mutation reactivateMembership($membershipId: String!) {
    reactivateMembership(membershipId: $membershipId)
  }
`;
